import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";
import type { Nullable } from "shared/types";
import type { BroadcastProvider } from "shared/types/mentions";

import type TvChannel from "./TvChannel";

@Model()
class TvCaption extends ApplicationRecord {
  static jsonapiType = "tv_captions";

  @Attr({ persist: false }) broadcastProvider?: Nullable<BroadcastProvider>;

  @Attr() endTime: number;

  @Attr() excludedFrom: string;

  @Attr() programExclusion: boolean;

  @HasMany() siblings: TvCaption[];

  @BelongsTo() source: TvChannel;

  @Attr() sourceId: number;

  @Attr() startTime: number;

  @Attr() text: string;

  @Attr({ persist: false }) tveyesEditorUrl: Nullable<string>;

  @Attr({ persist: false }) tveyesPlayerUrl: Nullable<string>;

  @Attr({ persist: false }) tveyesSlimPlayerUrl: Nullable<string>;

  @Attr({ persist: false }) type: string;
}

export default TvCaption;
